module.exports = __webpack_public_path__ + "assets/media/vokrug-1.7d908a2b.svg";